// extracted by mini-css-extract-plugin
module.exports = {"jobCard":"Jobs-module_jobCard_9ee8e"};